import { render, staticRenderFns } from "./ModalInfoExam.vue?vue&type=template&id=49612845&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ModalInfoExam.vue?vue&type=script&lang=js"
export * from "./ModalInfoExam.vue?vue&type=script&lang=js"
import style0 from "./ModalInfoExam.vue?vue&type=style&index=0&id=49612845&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports